const Footer: React.FC = () => {
    return (
        <>
        </>
    );
}

export default Footer;